import * as React from 'react';
import { ButtonType, CustomButton, Table } from "soprasteria-ui-library";
import { IEpiReport } from '../../../models/IEpiReport';
import { ITreatmentReport, ITreatmentReportEpiReport } from '../../../models/ITreatmentReport';
import { EpiReportInformation } from "./EpiReportInformation";
import { EpiReportModal } from "./EpiReportModal";

interface IEpiReportInfo {
    treatmentReport: ITreatmentReport;
    onSubmit: (epiReport: ITreatmentReportEpiReport, onCallEnd?: () => void) => void;
    onDelete: (epiReportId: number) => void;
}

export const EpiReport: React.FunctionComponent<IEpiReportInfo> = ({ treatmentReport, onSubmit, onDelete }) => {
    const [renderEpiReportModal, setRenderEpiReportModal] = React.useState<boolean>(false);
    const [selectedEpiReport, setSelectedEpiReport] = React.useState<IEpiReport>();

    React.useEffect(() => {
        if (treatmentReport.epiReport) {
            setSelectedEpiReport(treatmentReport.epiReport);
        } else {
            setSelectedEpiReport(undefined);
        }
    }, [treatmentReport.epiReport])

    const closeModal = () => {
        setRenderEpiReportModal(false);
    }

    const populateEpiReportModal = (data: IEpiReport) => {
        setSelectedEpiReport(data);
        setRenderEpiReportModal(true);
    }

    const onDeleteEpiReport = (epiReportId: number) => {
        const deleteEpiReport = window.confirm("Är du säker på att du vill ta bort EPI-rapporten?");
        if (deleteEpiReport) {
            onDelete(epiReportId);
        }
    }

    return (
        <section>
            <div className="row panel">
                <h5 className="col-6">EPI-rapport</h5>
                <div className="col-6 text text-right">
                    {
                        treatmentReport.isEditable && selectedEpiReport === undefined ?
                            <CustomButton id="creaate-epi" buttonText="Skapa EPI-rapport" data-toggle="modal" data-target="#epi-report-modal" buttonType={ButtonType.create} onClick={() => setRenderEpiReportModal(true)} />
                            : null
                    }
                </div>
            </div>
            {
                selectedEpiReport ?
                    <>
                        <div>
                            <EpiReportInformation epiReport={selectedEpiReport} populateEpiReportModal={populateEpiReportModal} onDelete={treatmentReport.isEditable ? onDeleteEpiReport : undefined} />
                        </div>


                    </>
                    : <Table><tbody><tr><td>Det finns ingen registrerad EPI-rapport</td></tr></tbody></Table>
            }
            {
                renderEpiReportModal ?
                    <EpiReportModal
                        epiReport={selectedEpiReport}
                        epiReportType={selectedEpiReport ? selectedEpiReport.epiReportTypeId : treatmentReport.epiReportTypeIdBasedOnAge}
                        patientId={treatmentReport.patientId}
                        onSubmit={onSubmit}
                        closeModal={closeModal} />
                    : null
            }
        </section>
    )
}